// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .private-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.layout-container {
  display: flex;
  flex: 1;
  position: relative;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
}

.sidebar.open {
  transform: translateX(0);
}

.content {
  flex: 1;
  padding: 20px;
}

@media screen and (min-width: 769px) {
  .sidebar {
    position: relative;
    transform: translateX(0);
  }

  .sidebar{
    position: fixed !important;
    top: 66px !important;
  }

  .sidebar.open {
    width: 50% !important;

  }
} */

.private-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.layout-container {
  display: flex;
  flex: 1 1;
  position: relative;
  overflow: hidden;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  z-index: 1100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  width: 250px;
  height: calc(100vh - 60px);
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
}

.sidebar.open {
  transform: translateX(0);
}

.content {
  flex: 1 1;
  overflow-y: auto;
  height: calc(100vh - 60px);
}

.footer_div{
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 99999 !important;
}

@media screen and (min-width: 769px) {
  .sidebar {
    position: relative;
    top: 0;
    height: 100vh;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,wCAAwC;EACxC,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,wBAAwB;EAC1B;AACF","sourcesContent":["/* .private-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.layout-container {\n  display: flex;\n  flex: 1;\n  position: relative;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 250px;\n  height: 100vh;\n  background-color: #fff;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  z-index: 1000;\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n}\n\n@media screen and (min-width: 769px) {\n  .sidebar {\n    position: relative;\n    transform: translateX(0);\n  }\n\n  .sidebar{\n    position: fixed !important;\n    top: 66px !important;\n  }\n\n  .sidebar.open {\n    width: 50% !important;\n\n  }\n} */\n\n.private-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.layout-container {\n  display: flex;\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background-color: #fff;\n  z-index: 1100;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar {\n  position: fixed;\n  top: 60px;\n  left: 0;\n  width: 250px;\n  height: calc(100vh - 60px);\n  background-color: #fff;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  z-index: 1000;\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n.content {\n  flex: 1;\n  overflow-y: auto;\n  height: calc(100vh - 60px);\n}\n\n.footer_div{\n  margin-top: 1rem;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 99999 !important;\n}\n\n@media screen and (min-width: 769px) {\n  .sidebar {\n    position: relative;\n    top: 0;\n    height: 100vh;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
